module.exports = __webpack_public_path__ + "static/media/employee_experience_1.03176f8b.png";